import { useState } from 'react'
import classnames from 'classnames'
import Button from '@components/Button'
import { AddressForm } from '@components/AddressForm'

const AddressSectionForm = ({ address, type, forceShowForm, buttonCaption, formCaption }) => {
    const [showBillingForm, setShowBillingForm] = useState(forceShowForm)
    const addressee = address.addressee || `${address.firstName} ${address.lastName}`

    return (
        <>
            {showBillingForm ? (
                <>
                    {formCaption}
                    <AddressForm
                        {...address}
                        addressee={addressee}
                        country={address.country ? address.country : undefined}
                        prefix={type}
                        withAddressee
                    />
                </>
            ) : (
                <>
                    {buttonCaption}
                    <Button
                        size="small"
                        btnStyle="link"
                        iconLeft="plus-round"
                        className={classnames('mt-3', 'mb-3')}
                        onClick={() => setShowBillingForm(true)}>
                        <T>{`subscription.purchase.btn.add.different.address.${type}`}</T>
                    </Button>
                </>
            )}
        </>
    )
}
export default AddressSectionForm
